import { Component } from '@verndale/core';

class SplashFormComponent extends Component {
  setupDefaults() {
    this.selectedInput = null;

    this.dom = {
      checkbox: this.$el.find('.splash-form__checkbox--consent'),
      modal: $('#consent_detail')
    };
  }

  addListeners() {
    this.dom.checkbox.on('click', ::this.handleCheckboxClick);
    this.dom.modal.on('click', 'a.confirm', ::this.handleDismissModal);
  }

  handleCheckboxClick(e) {
    e.preventDefault();
    this.selectedInput = $(e.currentTarget).find('input');

    if (!this.selectedInput.is(':checked')) {
      // Open Modal
      $('#consent_detail').awsModal();
    } else {
      this.selectedInput.prop('checked', false);
    }
  }

  handleDismissModal() {
    if (this.selectedInput) {
      this.selectedInput.prop('checked', true);
      this.selectedInput = null;
    }
  }
}

export default SplashFormComponent;
